import { add as addNotification } from 'store/reducers/notifications'

export const authRoute = (store) => ({
  authentication: false,
  onEnter: function (nextState, replace) { // require authentication
    const state = store.getState()
    const matched = nextState.routes[nextState.routes.length - 1]

    if (matched.authentication && !state.auth.isLoggedIn) {
      store.dispatch(addNotification('You must login to continue.', 'warning'))

      return store.dispatch({
        type: 'MISSING_LOGIN_TOKEN',
        redirectTo: `/login?nextPath=${nextState.location.pathname}`
      })
    } else if (matched.authentication === 'admin' && !state.auth.isAdmin) {
      return store.dispatch(addNotification('You don\'t have admin permissions to access that.'))
    }
  }
})



// WEBPACK FOOTER //
// ./src/helpers/routes.js